import { useEffect, useRef } from 'react';

const useDidMountEffect = (func, deps) =>
{
	const didMount = useRef(false);

	useEffect(() =>
	{
		if (didMount.current)
		{
			const cleanup = func();

			return cleanup;
		}
		else didMount.current = true;
	}, deps);
};

export default useDidMountEffect;